import { REPLICATION_SIZE } from '../../../utils/constants';
import {
  auditFields,
  buildReplication,
  getMutationIsActive,
  getMutationNumberValue,
  getMutationStringValue
} from '../utils';

/**
 * Pull builder for blood product type data
 *
 * @param {*} db RxDB database
 */
const pullBuilder = (doc) => {
  const where = doc ? `lastmodifiedAt_Gt: "${doc.lastmodifiedAt}"` : '';

  const query = `{
    listBloodProductTypes(
      limit: ${REPLICATION_SIZE}
      offset: 0
      ordering: "lastmodifiedAt,ASC"
      ${where}
    ) {
      results {
        id
        icode

        name
        details

        shelfLife
        shelfLifeUnit

        ${auditFields}
      }
    }
  }`;

  return { query, variables: {} };
};

/**
 * Push builder for blood product type data
 *
 * @param {*} db RxDB database
 */
const pushBuilder = (doc) => {
  const query = `
    mutation {
      upsertBloodProductType(
        input: {
          ${getMutationStringValue(doc, 'id')}

          ${getMutationStringValue(doc, 'name')}
          ${getMutationStringValue(doc, 'details')}

          ${getMutationNumberValue(doc, 'shelfLife')}
          ${getMutationStringValue(doc, 'shelfLifeUnit')}

          ${getMutationIsActive(doc)}
        }
      ) {
        id
      }
    }
  `;

  return { query, variables: {} };
};

/**
 * Synchronize blood product type data with GraphQL endpoint
 */
export const syncBloodProductType = (...args) => {
  return buildReplication(
    ...args,
    'bloodProductType',
    { pullBuilder, pullQuery: 'listBloodProductTypes' },
    { pushBuilder }
  );
};
